import { render, staticRenderFns } from "./AverageReadinessBanner.vue?vue&type=template&id=a544a954&scoped=true"
import script from "./AverageReadinessBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./AverageReadinessBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AverageReadinessBanner.vue?vue&type=style&index=0&id=a544a954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a544a954",
  null
  
)

export default component.exports